import { accessRole } from "../../helpers/access_role";
import ErrorAccess from "../../components/Error/Content/Access";
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";

import {
  apiRequest as baseApi,
  empSideMenuList as baseMenuList,
} from "../../services/adapters/base";

import IndexView from "./HomeAdmin/Index/View";
import CreateView from "./HomeAdmin/Create/View";
import DetailView from "./HomeAdmin/Detail/View";
import UpdateView from "./HomeAdmin/Update/View";

// Start Route Iqbal
import { default as SaudaraIndexView } from "./Keluarga/Saudara/Index/View";
import { default as SaudaraCreateView } from "./Keluarga/Saudara/Create/View";
import { default as SaudaraDetailView } from "./Keluarga/Saudara/Detail/View";
import { default as SaudaraUpdateView } from "./Keluarga/Saudara/Update/View";
import { default as SaudaraApproveView } from "./Keluarga/Saudara/Approve/View";

import { default as PengalamanKerjaIndexView } from "./PengalamanKerja/Index/View";
import { default as PengalamanKerjaCreateView } from "./PengalamanKerja/Create/View";
import { default as PengalamanKerjaDetailView } from "./PengalamanKerja/Detail/View";
import { default as PengalamanKerjaUpdateView } from "./PengalamanKerja/Update/View";
import { default as PengalamanKerjaApproveView } from "./PengalamanKerja/Approve/View";

import { default as IdentitasIndexView } from "./IdentitasPegawai/Index/View";
import { default as IdentitasApproveView } from "./IdentitasPegawai/Approve/View";
import { default as IdentitasUpdateView } from "./IdentitasPegawai/Update/View";

import { default as RiwayatPendidikanIndexView } from "./RiwayatPendidikan/Index/View";
import { default as RiwayatPendidikanCreateView } from "./RiwayatPendidikan/Create/View";
import { default as RiwayatPendidikanDetailView } from "./RiwayatPendidikan/Detail/View";
import { default as RiwayatPendidikanUpdateView } from "./RiwayatPendidikan/Update/View";
import { default as RiwayatPendidikanApproveView } from "./RiwayatPendidikan/Approve/View";
// End Route Iqbal

// Route Penghargaan
import { default as PenghargaanIndexView } from "./Penghargaan/Index/View";
import { default as PenghargaanCreateView } from "./Penghargaan/Create/View";
import { default as PenghargaanDetailView } from "./Penghargaan/Detail/View";
import { default as PenghargaanUpdateView } from "./Penghargaan/Update/View";

// Route Riwayat Nikah
import { default as RiwayatNikahIndexView } from "./RiwayatNikah/Index/View";
import { default as RiwayatNikahCreateView } from "./RiwayatNikah/Create/View";
import { default as RiwayatNikahUpdateView } from "./RiwayatNikah/Update/View";
import { default as RiwayatNikahDetailView } from "./RiwayatNikah/Detail/View";
import { default as RiwayatNikahApproveView } from "./RiwayatNikah/Approve/View";

// Route Diklat
import { default as DiklatIndexView } from "./Diklat/Index/View";
import { default as DiklatCreateView } from "./Diklat/Create/View";
import { default as DiklatUpdateView } from "./Diklat/Update/View";
import { default as DiklatDetailView } from "./Diklat/Detail/View";
import { default as DiklatApproveView } from "./Diklat/Approve/View";

// Route Penataran
import { default as PenataranIndexView } from "./Penataran/Index/View";
import { default as PenataranCreateView } from "./Penataran/Create/View";
import { default as PenataranDetailView } from "./Penataran/Detail/View";
import { default as PenataranUpdateView } from "./Penataran/Update/View";
import { default as PenataranApproveView } from "./Penataran/Approve/View";

// Route Kursus
import { default as KursusIndexView } from "./Kursus/Index/View";
import { default as KursusCreateView } from "./Kursus/Create/View";
import { default as KursusDetailView } from "./Kursus/Detail/View";
import { default as KursusUpdateView } from "./Kursus/Update/View";
// Route Mertua
import { default as MertuaIndexView } from "./Keluarga/Mertua/Index/View";
import { default as MertuaCreateView } from "./Keluarga/Mertua/Create/View";
import { default as MertuaDetailView } from "./Keluarga/Mertua/Detail/View";
import { default as MertuaUpdateView } from "./Keluarga/Mertua/Update/View";
import { default as MertuaApproveView } from "./Keluarga/Mertua/Approve/View";

// Route SKCPNS
import { default as SKCPNSApproveView } from "./SKCPNS/Approve/View";
import { default as SKCPNSIndexView } from "./SKCPNS/Index/View";
import { default as SKCPNSCreateView } from "./SKCPNS/Create/View";
import { default as SKCPNSUpdateView } from "./SKCPNS/Update/View";
import { default as SKCPNSDetailView } from "./SKCPNS/Detail/View";

// Route SKCP3K
import { default as SKCP3KApproveView } from "./SKCP3K/Approve/View";
import { default as SKCP3KIndexView } from "./SKCP3K/Index/View";
import { default as SKCP3KCreateView } from "./SKCP3K/Create/View";
import { default as SKCP3KUpdateView } from "./SKCP3K/Update/View";
import { default as SKCP3KDetailView } from "./SKCP3K/Detail/View";

// Route Anak
import { default as AnakIndexView } from "./Keluarga/Anak/Index/View";
import { default as AnakCreateView } from "./Keluarga/Anak/Create/View";
import { default as AnakDetailView } from "./Keluarga/Anak/Detail/View";
import { default as AnakUpdateView } from "./Keluarga/Anak/Update/View";
import { default as AnakApproveView } from "./Keluarga/Anak/Approve/View";

// Route Histori Organisasi
import { default as OrganizationhistoriIndexView } from "./Organisasi/Index/View";
import { default as OrganizationhistoriCreateView } from "./Organisasi/Create/View";
import { default as OrganizationhistoriDetailView } from "./Organisasi/Detail/View";
import { default as OrganizationhistoriUpdateView } from "./Organisasi/Update/View";

// Route Seminar Keahlian
import { default as SkillcertifictionIndexView } from "./Skillcertification/Index/View";
import { default as SkillcertifictionCreateView } from "./Skillcertification/Create/View";
import { default as SkillcertifictionDetailView } from "./Skillcertification/Detail/View";
import { default as SkillcertifictionUpdateView } from "./Skillcertification/Update/View";
import { default as SkillcertifictionApproveView } from "./Skillcertification/Approve/View";

// Route Orang Tua
import { default as OrangTuaIndexView } from "./Keluarga/OrangTua/Index/View";
import { default as OrangTuaCreateView } from "./Keluarga/OrangTua/Create/View";
import { default as OrangTuaDetailView } from "./Keluarga/OrangTua/Detail/View";
import { default as OrangTuaUpdateView } from "./Keluarga/OrangTua/Update/View";
import { default as OrangTuaApproveView } from "./Keluarga/OrangTua/Approve/View";

// Riwayat Jabatan
import { default as RiwayatJabatanIndexView } from "./RiwayatJabatan/Index/View";
import { default as RiwayatJabatanCreateView } from "./RiwayatJabatan/Create/View";
import { default as RiwayatJabatanDetailView } from "./RiwayatJabatan/Detail/View";
import { default as RiwayatJabatanUpdateView } from "./RiwayatJabatan/Update/View";

// Riwayat SKPNS
import { default as SKPNSIndexView } from "./SKPNS/Index/View";
import { default as SKPNSCreateView } from "./SKPNS/Create/View";
import { default as SKPNSDetailView } from "./SKPNS/Detail/View";
import { default as SKPNSUpdateView } from "./SKPNS/Update/View";
import { default as SKPNSApproveView } from "./SKPNS/Approve/View";

// Riwayat SKPPPK
import { default as SKP3KIndexView } from "./SKP3K/Index/View";
import { default as SKP3KCreateView } from "./SKP3K/Create/View";
import { default as SKP3KDetailView } from "./SKP3K/Detail/View";
import { default as SKP3KUpdateView } from "./SKP3K/Update/View";
import { default as SKP3KApproveView } from "./SKP3K/Approve/View";

// Route Cuti
import { default as CutiIndexView } from "./Cuti/Index/View";
import { default as CutiCreateView } from "./Cuti/Create/View";
import { default as CutiUpdateView } from "./Cuti/Update/View";
import { default as CutiDetailView } from "./Cuti/Detail/View";
import { default as CutiApproveView } from "./Cuti/Approve/View";

// Riwayat Penugasan
import { default as RiwayatpenugasanIndexView } from "./RiwayatPenugasan/Index/View";
import { default as RiwayatpenugasanCreateView } from "./RiwayatPenugasan/Create/View";
import { default as RiwayatpenugasanDetailView } from "./RiwayatPenugasan/Detail/View";
import { default as RiwayatpenugasanUpdateView } from "./RiwayatPenugasan/Update/View";

// Route Seminar
import { default as SeminarIndexView } from "./Seminar/Index/View";
import { default as SeminarCreateView } from "./Seminar/Create/View";
import { default as SeminarDetailView } from "./Seminar/Detail/View";
import { default as SeminarUpdateView } from "./Seminar/Update/View";
import { default as SeminarApproveView } from "./Seminar/Approve/View";

// Route Penilaian
import { default as PenilaianIndexView } from "./Penilaian/Index/View";
import { default as PenilaianCreateView } from "./Penilaian/Create/View";
import { default as PenilaianDetailView } from "./Penilaian/Detail/View";
import { default as PenilaianUpdateView } from "./Penilaian/Update/View";

// Route SK Pensiun
import { default as SKPensiunIndexView } from "./SKPensiun/Index/View";
import { default as SKPensiunCreateView } from "./SKPensiun/Create/View";
import { default as SKPensiunDetailView } from "./SKPensiun/Detail/View";
import { default as SKPensiunUpdateView } from "./SKPensiun/Update/View";

// Route Riwayat Sumpah
import { default as RiwayatsumpahIndexView } from "./RiwayatSumpah/Index/View";
import { default as RiwayatsumpahCreateView } from "./RiwayatSumpah/Create/View";
import { default as RiwayatsumpahDetailView } from "./RiwayatSumpah/Detail/View";
import { default as RiwayatsumpahUpdateView } from "./RiwayatSumpah/Update/View";
import { default as RiwayatsumpahApproveView } from "./RiwayatSumpah/Approve/View";

// Route Riwayat Hukuman
// import { default as RiwayatHukumanIndexView } from "./RiwayatHukuman/Index/View"
import { default as RiwayatHukumanIndexView } from "./RiwayatHukuman/IndexNew/View";
import { default as RiwayatHukumanDetailView } from "./RiwayatHukuman/Detail/View";

// Riwayat Pensiun
import { default as PensiunPegawaiIndexView } from "./PensiunPegawai/Index/View";
import { default as PensiunPegawaiCreateView } from "./PensiunPegawai/Create/View";
import { default as PensiunPegawaiDetailView } from "./PensiunPegawai/Detail/View";
import { default as PensiunPegawaiUpdateView } from "./PensiunPegawai/Update/View";

// Riwayat Pangkat
import { default as RiwayatPangkatIndexView } from "./RiwayatPangkat/Index/View";
import { default as RiwayatPangkatDetailView } from "./RiwayatPangkat/Detail/View";
import { default as RiwayatPangkatUploadSKView } from "./RiwayatPangkat/UploadSK/View";
import { default as RiwayatPangkatCreateView } from "./RiwayatPangkat/Create/View";
import { default as RiwayatPangkatUpdateView } from "./RiwayatPangkat/Update/View";
import { default as RiwayatPangkatApproveView } from "./RiwayatPangkat/Approve/View";

// Riwayat Gaji
import { default as RiwayatGajiIndexView } from "./RiwayatGaji/Index/View";
import { default as RiwayatGajiDetailView } from "./RiwayatGaji/Detail/View";

//Dokumen Pelantikan
import { default as DokumenPelantikanIndexView } from "./DokumenPelantikan/Index/View";
import { default as DokumenPelantikanDetailView } from "./DokumenPelantikan/Detail/View";
import { default as DokumenPelantikanCreateView } from "./DokumenPelantikan/Create/View";
import { default as DokumenPelantikanUpdateView } from "./DokumenPelantikan/Update/View";

// Riwayat Angka Kredit
import { default as RiwayatAngkaKreditIndexView } from "./RiwayatAngkaKredit/Index/View";
import { default as RiwayatAngkaKreditCreateView } from "./RiwayatAngkaKredit/Create/View";
import { default as RiwayatAngkaKreditDetailView } from "./RiwayatAngkaKredit/Detail/View";
import { default as RiwayatangkakreditDetailJabfungView } from "./RiwayatAngkaKredit/DetailJabfung/View";
import { default as RiwayatAngkaKreditUpdateView } from "./RiwayatAngkaKredit/Update/View";
//Tambahan
import { default as RiwayatAngkaKreditDetailViewNew } from "./RiwayatAngkaKredit/Details/View";

//Undangan Pelantikan
import { default as UndanganPelantikanIndexView } from "./UndanganPelantikan/Index/View";
import { default as UndanganPelantikanDetailView } from "./UndanganPelantikan/Detail/View";
import { default as UndanganPelantikanCreateView } from "./UndanganPelantikan/Create/View";
import { default as UndanganPelantikanUpdateView } from "./UndanganPelantikan/Update/View";

//Diklat admin struktural
import { default as AdminDiklatStrukturalIndexView } from "./Diklat/Admin/struktural/Index/View";
import { default as AdminDiklatStrukturalDetailView } from "./Diklat/Admin/struktural/Detail/View";
import { default as AdminDiklatStrukturalCreateView } from "./Diklat/Admin/struktural/Create/View";
import { default as AdminDiklatStrukturalUpdateView } from "./Diklat/Admin/struktural/Update/View";
//struktural/Diklat Fungsional
import { default as AdminDiklatFungsionalIndexView } from "./Diklat/Admin/fungsional/Index/View";
import { default as AdminDiklatFungsionalDetailView } from "./Diklat/Admin/fungsional/Detail/View";
import { default as AdminDiklatFungsionalCreateView } from "./Diklat/Admin/fungsional/Create/View";
import { default as AdminDiklatFungsionalUpdateView } from "./Diklat/Admin/fungsional/Update/View";
//struktural/Diklat Teknis
import { default as AdminDiklatTeknisIndexView } from "./Diklat/Admin/teknis/Index/View";
import { default as AdminDiklatTeknisDetailView } from "./Diklat/Admin/teknis/Detail/View";
import { default as AdminDiklatTeknisCreateView } from "./Diklat/Admin/teknis/Create/View";
import { default as AdminDiklatTeknisUpdateView } from "./Diklat/Admin/teknis/Update/View";
//struktural/Diklat Kursus
import { default as AdminDiklatKursusIndexView } from "./Kursus/Admin/Index/View";
import { default as AdminDiklatKursusDetailView } from "./Kursus/Admin/Detail/View";
import { default as AdminDiklatKursusCreateView } from "./Kursus/Admin/Create/View";
import { default as AdminDiklatKursusUpdateView } from "./Kursus/Admin/Update/View";
//struktural/Diklat Seminar kursus
import { default as AdminDiklatSeminarIndexView } from "./Seminar/Admin/Index/View";
import { default as AdminDiklatSeminarDetailView } from "./Seminar/Admin/Detail/View";
import { default as AdminDiklatSeminarCreateView } from "./Seminar/Admin/Create/View";
import { default as AdminDiklatSeminarUpdateView } from "./Seminar/Admin/Update/View";

const RouteView = (props) => {
  useEffect(() => {
    loadData();
  }, []);

  const queryParams = new URLSearchParams(props.location.search);
  const _id = queryParams.get("id");
  const _uuid = queryParams.get("uuid");
  const _create = queryParams.get("create");
  const _detail = queryParams.get("detail");
  const _detailjabfung = queryParams.get("detailjabfung");
  const _update = queryParams.get("update");
  const _delete = queryParams.get("delete");
  const _approve = queryParams.get("approve");
  const _print = queryParams.get("print");
  const _upload_sk = queryParams.get("upload_sk");
  const _details = queryParams.get("details");

  // Route SubModule
  const saudara = queryParams.get("saudara");
  const penghargaan = queryParams.get("penghargaan");
  const riwayatNikah = queryParams.get("riwayat_nikah");
  const pengalaman_kerja = queryParams.get("pengalaman_kerja");
  const identitas = queryParams.get("identitas");
  const diklat = queryParams.get("diklat");
  const penataran = queryParams.get("penataran");
  const kursus = queryParams.get("kursus");
  const mertua = queryParams.get("mertua");
  const skcpns = queryParams.get("skcpns");
  const skcp3k = queryParams.get("skcp3k");
  const anak = queryParams.get("anak");
  const organizationhistori = queryParams.get("historiorganisasi");
  const skillcertification = queryParams.get("skillcertification");
  const orangtua = queryParams.get("orangtua");
  const riwayatjabatan = queryParams.get("riwayatjabatan");
  const skpns = queryParams.get("skpns");
  const skp3k = queryParams.get("skp3k");
  const cuti = queryParams.get("cuti");
  const riwayatpenugasan = queryParams.get("riwayatpenugasan");
  const seminar = queryParams.get("seminar");
  const penilaian = queryParams.get("penilaian");
  const skpensiun = queryParams.get("skpensiun");
  const pensiunpegawai = queryParams.get("pensiunpegawai");
  const riwayatsumpah = queryParams.get("riwayatsumpah");
  const riwayathukuman = queryParams.get("riwayathukuman");
  const riwayat_pendidikan = queryParams.get("riwayat_pendidikan");
  const riwayat_pangkat = queryParams.get("riwayat_pangkat");
  const riwayat_gaji = queryParams.get("riwayat_gaji");
  const dokumen_pelantikan = queryParams.get("dokumen_pelantikan");
  const riwayat_angkakredit = queryParams.get("riwayat_angkakredit");
  const undangan_pelantikan = queryParams.get("undangan_pelantikan");
  const AdminDiklatStruktural = queryParams.get("admindiklatstruktural");
  const AdminDiklatFungsional = queryParams.get("admindiklatFungsionam");
  const AdminDiklatTeknis = queryParams.get("admindiklatteknis");
  const AdminDiklatKursus = queryParams.get("admindiklatkursus");
  const AdminDiklatSertifikasi = queryParams.get("admindiklatsertifikasi");

  if (saudara !== null) {
    if (_create != null) {
      return accessRole("create") ? <SaudaraCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <SaudaraDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <SaudaraUpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("approve") ? <SaudaraApproveView /> : <ErrorAccess />;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <SaudaraIndexView /> : <ErrorAccess />;
  } else if (penghargaan !== null) {
    if (_create != null) {
      return accessRole("create") ? <PenghargaanCreateView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? (
        <PenghargaanUpdateView id={_id} />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <PenghargaanDetailView id={_id} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <PenghargaanIndexView /> : <ErrorAccess />;
  } else if (riwayatNikah != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatNikahCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatNikahUpdateView id={_id} />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <RiwayatNikahDetailView id={_id} />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <RiwayatNikahApproveView />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <RiwayatNikahIndexView /> : <ErrorAccess />;
  } else if (pengalaman_kerja !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <PengalamanKerjaCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <PengalamanKerjaDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <PengalamanKerjaUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("update") ? (
        <PengalamanKerjaApproveView />
      ) : (
        <ErrorAccess />
      );
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <PengalamanKerjaIndexView /> : <ErrorAccess />;
  } else if (identitas !== null) {
    if (_create != null) {
      return accessRole("create") ? null : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? null : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <IdentitasUpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("approve") ? <IdentitasApproveView /> : <ErrorAccess />;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <IdentitasIndexView /> : <ErrorAccess />;
  } else if (orangtua !== null) {
    if (_create != null) {
      return accessRole("create") ? <OrangTuaCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <OrangTuaDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <OrangTuaUpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("approve") ? <OrangTuaApproveView /> : <ErrorAccess />;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <OrangTuaIndexView /> : <ErrorAccess />;
  } else if (riwayathukuman !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatHukumanIndexView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <RiwayatHukumanDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatHukumanIndexView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <RiwayatHukumanIndexView /> : <ErrorAccess />;
  } else if (riwayatjabatan !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatJabatanCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <RiwayatJabatanDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatJabatanUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <RiwayatJabatanIndexView /> : <ErrorAccess />;
  } else if (pensiunpegawai !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <PensiunPegawaiCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <PensiunPegawaiDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <PensiunPegawaiUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <PensiunPegawaiIndexView /> : <ErrorAccess />;
  } else if (skpns !== null) {
    if (_create != null) {
      return accessRole("create") ? <SKPNSCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <SKPNSDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <SKPNSUpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("update") ? (
        <SKPNSApproveView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <SKPNSIndexView /> : <ErrorAccess />;
  } else if (skp3k !== null) {
    if (_create != null) {
      return accessRole("create") ? <SKP3KCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <SKP3KDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <SKP3KUpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("update") ? (
        <SKP3KApproveView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <SKP3KIndexView /> : <ErrorAccess />;
  } else if (diklat != null) {
    const type = queryParams.get("type");
    if (_create != null) {
      return accessRole("create") ? (
        <DiklatCreateView type={type} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <DiklatUpdateView type={type} uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <DiklatDetailView type={type} uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <DiklatApproveView type={type} uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }

    return accessRole("read") ? (
      <DiklatIndexView type={type} />
    ) : (
      <ErrorAccess />
    );
  } else if (penataran != null) {
    if (_create != null) {
      return accessRole("create") ? <PenataranCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? (
        <PenataranDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <PenataranUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <PenataranApproveView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <PenataranIndexView /> : <ErrorAccess />;
  } else if (kursus != null) {
    if (_create != null) {
      return accessRole("create") ? <KursusCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? (
        <KursusDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <KursusUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <KursusIndexView /> : <ErrorAccess />;
  } else if (mertua !== null) {
    if (_create != null) {
      return accessRole("create") ? <MertuaCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <MertuaDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <MertuaUpdateView /> : <ErrorAccess />;
    } else if (_approve != null) {
      return accessRole("approve") ? <MertuaApproveView /> : <ErrorAccess />;
    }
    return accessRole("read") ? <MertuaIndexView /> : <ErrorAccess />;
  } else if (skcpns !== null) {
    if (_create != null) {
      return accessRole("create") ? <SKCPNSCreateView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? (
        <SKCPNSUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <SKCPNSDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <SKCPNSApproveView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <SKCPNSIndexView /> : <ErrorAccess />;
  } else if (skcp3k !== null) {
    if (_create != null) {
      return accessRole("create") ? <SKCP3KCreateView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? (
        <SKCP3KUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <SKCP3KDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <SKCP3KApproveView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <SKCP3KIndexView /> : <ErrorAccess />;
  } else if (anak != null) {
    if (_create != null) {
      return accessRole("create") ? <AnakCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <AnakDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <AnakUpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("approve") ? <AnakApproveView /> : <ErrorAccess />;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <AnakIndexView /> : <ErrorAccess />;
  } else if (organizationhistori !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <OrganizationhistoriCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <OrganizationhistoriDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <OrganizationhistoriUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? (
      <OrganizationhistoriIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (skillcertification !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <SkillcertifictionCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <SkillcertifictionDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <SkillcertifictionUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <SkillcertifictionApproveView />
      ) : (
        <ErrorAccess />
      );
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? (
      <SkillcertifictionIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (cuti !== null) {
    if (_create != null) {
      return accessRole("create") ? <CutiCreateView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? (
        <CutiUpdateView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <CutiDetailView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <CutiApproveView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <CutiIndexView /> : <ErrorAccess />;
  } else if (riwayatpenugasan !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatpenugasanCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <RiwayatpenugasanDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatpenugasanUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <RiwayatpenugasanIndexView /> : <ErrorAccess />;
  } else if (seminar != null) {
    if (_create != null) {
      return accessRole("create") ? <SeminarCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? (
        <SeminarDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <SeminarUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <SeminarApproveView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <SeminarIndexView /> : <ErrorAccess />;
  } else if (penilaian != null) {
    if (_create != null) {
      return accessRole("create") ? <PenilaianCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? (
        <PenilaianDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <PenilaianUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? <PenilaianIndexView /> : <ErrorAccess />;
  } else if (skpensiun !== null) {
    if (_create != null) {
      return accessRole("create") ? <SKPensiunCreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <SKPensiunDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <SKPensiunUpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <SKPensiunIndexView /> : <ErrorAccess />;
  } else if (riwayatsumpah !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatsumpahCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? <RiwayatsumpahDetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatsumpahUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <RiwayatsumpahApproveView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <RiwayatsumpahIndexView /> : <ErrorAccess />;
  } else if (riwayat_pendidikan !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatPendidikanCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <RiwayatPendidikanDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatPendidikanUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return accessRole("update") ? (
        <RiwayatPendidikanApproveView />
      ) : (
        <ErrorAccess />
      );
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? (
      <RiwayatPendidikanIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (riwayat_pangkat !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatPangkatCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatPangkatUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("update") ? (
        <RiwayatPangkatDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_upload_sk != null) {
      return accessRole("read") ? (
        <RiwayatPangkatUploadSKView />
      ) : (
        <ErrorAccess />
      );
    } else if (_approve != null) {
      return accessRole("approve") ? (
        <RiwayatPangkatApproveView />
      ) : (
        <ErrorAccess />
      );
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <RiwayatPangkatIndexView /> : <ErrorAccess />;
  } else if (riwayat_gaji !== null) {
    if (_create != null) {
      return accessRole("create") ? null : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <RiwayatGajiDetailView /> : <ErrorAccess />;
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? <RiwayatGajiIndexView /> : <ErrorAccess />;
  } else if (dokumen_pelantikan != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <DokumenPelantikanCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <DokumenPelantikanDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <DokumenPelantikanUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? (
      <DokumenPelantikanIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (riwayat_angkakredit !== null) {
    if (_create != null) {
      return accessRole("create") ? (
        <RiwayatAngkaKreditCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <RiwayatAngkaKreditDetailView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detailjabfung != null) {
      return accessRole("read") ? (
        <RiwayatangkakreditDetailJabfungView />
      ) : (
        <ErrorAccess />
      );
    } 
    else if (_details != null) {
      return accessRole("read") ? (
        <RiwayatAngkaKreditDetailViewNew />
      ) : (
        <ErrorAccess />
      );
    } 
    
    else if (_update != null) {
      return accessRole("update") ? (
        <RiwayatAngkaKreditUpdateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_delete != null) {
      return null;
      // } else if (_approve != null) {
      //   return accessRole('update') ? <RiwayatAngkaKreditApproveView /> : <ErrorAccess />
    } else if (_print != null) {
      return null;
    }
    return accessRole("read") ? (
      <RiwayatAngkaKreditIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (undangan_pelantikan != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <UndanganPelantikanCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <UndanganPelantikanDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <UndanganPelantikanUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? (
      <UndanganPelantikanIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (AdminDiklatStruktural != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <AdminDiklatStrukturalCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <AdminDiklatStrukturalDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <AdminDiklatStrukturalUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? (
      <AdminDiklatStrukturalIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (AdminDiklatFungsional != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <AdminDiklatFungsionalCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <AdminDiklatFungsionalDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <AdminDiklatFungsionalUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? (
      <AdminDiklatFungsionalIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (AdminDiklatTeknis != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <AdminDiklatTeknisCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <AdminDiklatTeknisDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <AdminDiklatTeknisUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? (
      <AdminDiklatTeknisIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (AdminDiklatKursus != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <AdminDiklatKursusCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <AdminDiklatKursusDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <AdminDiklatKursusUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? (
      <AdminDiklatKursusIndexView />
    ) : (
      <ErrorAccess />
    );
  } else if (AdminDiklatSertifikasi != null) {
    if (_create != null) {
      return accessRole("create") ? (
        <AdminDiklatSeminarCreateView />
      ) : (
        <ErrorAccess />
      );
    } else if (_detail != null) {
      return accessRole("read") ? (
        <AdminDiklatSeminarDetailView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else if (_update != null) {
      return accessRole("update") ? (
        <AdminDiklatSeminarUpdateView id={_uuid} />
      ) : (
        <ErrorAccess />
      );
    }
    return accessRole("read") ? (
      <AdminDiklatSeminarIndexView />
    ) : (
      <ErrorAccess />
    );
  } else {
    if (_create != null) {
      return accessRole("create") ? <CreateView /> : <ErrorAccess />;
    } else if (_detail != null) {
      return accessRole("read") ? <DetailView /> : <ErrorAccess />;
    } else if (_update != null) {
      return accessRole("update") ? <UpdateView /> : <ErrorAccess />;
    } else if (_delete != null) {
      return null;
    } else if (_approve != null) {
      return null;
    } else if (_print != null) {
      return null;
    }

    // Jika Admin
    if (accessRole("approve")) {
      return accessRole("read") ? <IndexView /> : <ErrorAccess />;
    } else {
      return accessRole("read") ? <IdentitasIndexView /> : <ErrorAccess />;
    }
  }
};

// Load Kepegawaian SideMenu Data and Save to SessionStorage
let peg_uuid =
  JSON.parse(localStorage.getItem("userdata")) != null
    ? JSON.parse(localStorage.getItem("userdata")).employee_uuid
    : "";
if (accessRole("approve")) {
  peg_uuid =
    JSON.parse(localStorage.getItem("employeeSelected")) != null
      ? JSON.parse(localStorage.getItem("employeeSelected")).employee_uuid
      : "";
}
const loadData = async () => {
  await baseApi("get", baseMenuList, {
    params: { uuid: peg_uuid },
    body: null,
    cancelToken: null,
  }).then((result) => {
    if (result.status) {
      const response = result.response;
      sessionStorage.setItem("kepegawaianSideMenu", JSON.stringify(response));
    }
  });
};
export default RouteView;
